import { render, staticRenderFns } from "./cert-template-select.vue?vue&type=template&id=52ec4a54"
import script from "./cert-template-select.vue?vue&type=script&lang=js"
export * from "./cert-template-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports